/* PREPAID RENEWALS -- the shared screen pieces (prepaid renewals part 2, 2026-10-29). ONE control, used by the Step-6 wizard's
 * Prepaid sub-step and the Vendor Dashboard's Prepaid tab; the plans behind it are utils/prepaidRenewals.js.
 *   PrepaidRenewsCell  -- the Renews answer: Yes / No, or "—" for a row the generator refuses; an UNANSWERED row shows the
 *                         engine's suggestion marked "suggested -- confirm or change" (12.5 rule 92) with its reason on hover.
 *   PrepaidRenewalChip -- "renewal of <vendor> <start>" on a generated row.
 *   PrepaidRenewsFlagged -- the edited renewals kept when Renews was turned off, each with the operator's two choices.
 * The host wraps these in <ViewOnly canEdit> -- a viewer sees them, greyed. Plain ASCII except the em-dash glyph (—). */
import React from 'react';

const FONT = "'DM Sans',-apple-system,sans-serif";
const btn = (on) => ({
  padding: '2px 8px', borderRadius: 6, fontSize: 11, fontWeight: 600, fontFamily: FONT, cursor: 'pointer',
  border: on ? '1px solid #2E86C1' : '1px solid rgba(0,0,0,0.15)', background: on ? 'rgba(46,134,193,0.10)' : '#fff',
  color: on ? '#2E86C1' : '#6B7094',
});

export function PrepaidRenewsCell({ view, onAnswer }) {
  if (!view) return null;
  if (view.dash) {
    return <span title={'No renewal: ' + view.dash} data-renews="dash" style={{ color: '#B0B3C8', fontFamily: FONT }}>{'—'}</span>;
  }
  const a = view.answer;
  return (
    <span data-renews={a === true ? 'yes' : a === false ? 'no' : 'unanswered'} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap', fontFamily: FONT }}>
      <button type="button" aria-label="Renews: Yes" onClick={() => onAnswer && a !== true && onAnswer(true)} style={btn(a === true)}>Yes</button>
      <button type="button" aria-label="Renews: No" onClick={() => onAnswer && a !== false && onAnswer(false)} style={btn(a === false)}>No</button>
      {a == null && (
        <span title={view.reason} data-renews-suggest={view.suggest ? 'yes' : 'no'}
          style={{ fontSize: 10, padding: '1px 5px', borderRadius: 3, background: '#FFF4E0', color: '#8A5B00', fontWeight: 600 }}>
          {(view.suggest ? 'Yes' : 'No') + ' · suggested — confirm or change'}
        </span>
      )}
    </span>
  );
}

export function PrepaidRenewalChip({ label }) {
  if (!label) return null;
  return (
    <span data-renewal-of={label} title="A renewal generated from the contract it renews; edit it to change it (the later renewals follow)."
      style={{ marginLeft: 6, fontSize: 10, padding: '1px 5px', borderRadius: 3, background: '#E8F1FE', color: '#1A73E8', fontWeight: 600, whiteSpace: 'nowrap', fontFamily: FONT }}>
      {'renewal of ' + label}
    </span>
  );
}

export function PrepaidRenewsFlagged({ items, onKeep, onDelete }) {
  if (!items || !items.length) return null;
  return (
    <div data-renews-flagged="1" style={{ padding: 12, margin: '12px 0', background: '#FFF8E7', border: '1px solid #F0D9A0', borderRadius: 8, fontSize: 12, fontFamily: FONT, color: '#6B5A2E' }}>
      <strong>{items.length === 1 ? 'An edited renewal was kept' : items.length + ' edited renewals were kept'}</strong>
      {' — Renews was turned off, but you changed '}{items.length === 1 ? 'this renewal' : 'these renewals'}{' by hand. Choose what happens to each:'}
      {items.map(it => (
        <div key={it.ref} style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6 }}>
          <span style={{ fontWeight: 600 }}>{it.label}</span>
          <button type="button" onClick={() => onKeep(it.ref)} style={btn(false)}>Keep as a stand-alone contract</button>
          <button type="button" onClick={() => onDelete(it.ref)} style={{ ...btn(false), color: '#B42318' }}>Delete it</button>
        </div>
      ))}
    </div>
  );
}
